export function findListIndizes(list, predicate) {
    return list === null || list === void 0 ? void 0 : list.map((item, index) => predicate(item) ? index : -1).filter(index => index >= 0);
}
export function findLast(list, predicate) {
    if (!list) {
        return undefined;
    }
    for (let i = list.length - 1; i >= 0; i--) {
        if (predicate(list[i])) {
            return list[i];
        }
    }
    return undefined;
}
//# sourceMappingURL=list.js.map
